"use strict";
/**
 * API Configuration
 *
 * Configures base URLs and settings for API communication with skylab-api.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_CONFIG = void 0;
// Validate SKYLAB_API_URL is configured
const SKYLAB_API_URL = process.env.SKYLAB_API_URL;
if (!SKYLAB_API_URL) {
    throw new Error('SKYLAB_API_URL environment variable is required');
}
// Validate HTTPS in production
if (process.env.NODE_ENV === 'production' && !SKYLAB_API_URL.startsWith('https://')) {
    throw new Error('SKYLAB_API_URL must use HTTPS in production');
}
// API Configuration
exports.API_CONFIG = {
    BASE_URL: SKYLAB_API_URL,
    TIMEOUT: 30000, // 30 seconds
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000, // 1 second
    ENABLE_LOGGING: process.env.NODE_ENV === 'development',
};
